import { render } from "./TabbarItem.vue?vue&type=template&id=0ea3b3db&scoped=true&ts=true"
import script from "./TabbarItem.vue?vue&type=script&lang=ts"
export * from "./TabbarItem.vue?vue&type=script&lang=ts"

import "./TabbarItem.vue?vue&type=style&index=0&id=0ea3b3db&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ea3b3db"]])

export default __exports__